import Quill from "quill";

const Embed = Quill.import("blots/embed");

export class MentionBlot extends Embed {
  static create(value) {
    const outerNode = super.create();

    // Create the inner span
    const innerSpan = document.createElement("span");
    innerSpan.setAttribute("data-id", value.id);
    innerSpan.setAttribute("data-value", value.value);
    innerSpan.classList.add("mention");
    innerSpan.setAttribute("contenteditable", "false");
    innerSpan.textContent = `@${value.value}`;

    // Append the inner span to the outer node
    outerNode.appendChild(innerSpan);

    // Add a zero-width space to prevent cursor issues
    const space = document.createTextNode("\u200B");
    outerNode.appendChild(space);

    return outerNode;
  }

  static value(node) {
    const innerSpan = node.querySelector("span.mention");
    if (innerSpan) {
      return {
        id: innerSpan.getAttribute("data-id"),
        value: innerSpan.getAttribute("data-value"),
      };
    }
  }

  static formats(node) {
    return MentionBlot.value(node);
  }
}

MentionBlot.blotName = "mention";
MentionBlot.tagName = "span";

Quill.register(MentionBlot);
